export const STATUS_OPTIONS_MAP = {
  INBOX: "inbox",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;

export const MODERATION_TABS = ["inbox", "approved", "rejected"];

export const TAB_QUERY_NAME = "status";

export const I18N_ROOT = "settings.moderation";

export const FROM_FILTER = "from";
export const CONTENT_TYPE_FILTER = "content_type";
export const REASON_TYPE_FILTER = "reason_type";
export const FLAGGED_BY_FILTER = "flagged_by";
export const FILTER_BAR_FILTERS = [
  FROM_FILTER,
  CONTENT_TYPE_FILTER,
  REASON_TYPE_FILTER,
  FLAGGED_BY_FILTER,
] as const;
